import { Component, OnInit, Input, Injector } from '@angular/core';
import { AppComponentBase } from '../../services/AppComponentBase';

@Component({
  selector: '[social-post]',
  template: require('./social-post.component.html'),
  styles: [require('./social-post.component.css')]
})
export class SocialPostComponent extends AppComponentBase implements OnInit {

  @Input()
  public provider!: string;

  public get post()
  {
    return this.shareService.lastPosts[this.provider];
  }

  public fullMode: boolean = false;

  constructor(injector: Injector) { super(injector); }

  ngOnInit() {
  }

  switchFull()
  { 
    this.fullMode = !this.fullMode;
  }
}
